// extracted by mini-css-extract-plugin
export default {"TopMenu":"TopMenu__TopMenu___u2BcO"};